import { Box, Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { Context } from '../../../App';

// ── SVG Icons ──────────────────────────────────────────────────────────────
const OutstandingSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.2C9.41667 2.4 9.77917 1.91667 10.2875 1.55C10.7958 1.18333 11.3667 1 12 1C12.6333 1 13.2042 1.18333 13.7125 1.55C14.2208 1.91667 14.5833 2.4 14.8 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19ZM7 17H14V15H7V17ZM7 13H17V11H7V13ZM7 9H17V7H7V9ZM12.5375 4.0375C12.6792 3.89583 12.75 3.71667 12.75 3.5C12.75 3.28333 12.6792 3.10417 12.5375 2.9625C12.3958 2.82083 12.2167 2.75 12 2.75C11.7833 2.75 11.6042 2.82083 11.4625 2.9625C11.3208 3.10417 11.25 3.28333 11.25 3.5C11.25 3.71667 11.3208 3.89583 11.4625 4.0375C11.6042 4.17917 11.7833 4.25 12 4.25C12.2167 4.25 12.3958 4.17917 12.5375 4.0375Z"
            fill="#006CDD"
        />
    </svg>
);

const CheckBoxOutlinedSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M10.6 16.05L17.65 9L16.25 7.6L10.6 13.25L7.75 10.4L6.35 11.8L10.6 16.05ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.2C9.41667 2.4 9.77917 1.91667 10.2875 1.55C10.7958 1.18333 11.3667 1 12 1C12.6333 1 13.2042 1.18333 13.7125 1.55C14.2208 1.91667 14.5833 2.4 14.8 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19ZM12.5375 4.0375C12.6792 3.89583 12.75 3.71667 12.75 3.5C12.75 3.28333 12.6792 3.10417 12.5375 2.9625C12.3958 2.82083 12.2167 2.75 12 2.75C11.7833 2.75 11.6042 2.82083 11.4625 2.9625C11.3208 3.10417 11.25 3.28333 11.25 3.5C11.25 3.71667 11.3208 3.89583 11.4625 4.0375C11.6042 4.17917 11.7833 4.25 12 4.25C12.2167 4.25 12.3958 4.17917 12.5375 4.0375Z"
            fill="#19B836"
        />
    </svg>
);

const EditCalendarOutlinedSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M5 8H19V6H5V8ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V11.675C20.6833 11.525 20.3583 11.4 20.025 11.3C19.6917 11.2 19.35 11.125 19 11.075V10H5V20H11.3C11.4167 20.3667 11.5542 20.7167 11.7125 21.05C11.8708 21.3833 12.0583 21.7 12.275 22H5ZM14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375ZM19.675 20.375L20.375 19.675L18.5 17.8V15H17.5V18.2L19.675 20.375Z"
            fill="#2789EF"
        />
    </svg>
);

const EventBusyOutlinedSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M9.7 18.7L8.3 17.3L10.6 15L8.3 12.7L9.7 11.3L12 13.6L14.3 11.3L15.7 12.7L13.4 15L15.7 17.3L14.3 18.7L12 16.4L9.7 18.7ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z"
            fill="#EF272E"
        />
    </svg>
);

// ── Config ─────────────────────────────────────────────────────────────────
const cardConfig = [
    { key: 'outstanding', label: 'Outstanding Requests', border: '1px solid #006CDD', icon: OutstandingSvg },
    { key: 'accepted', label: 'Accepted Requests', border: '1px solid #19B836', icon: CheckBoxOutlinedSvg },
    { key: 'proposed', label: 'Proposed New Time', border: '1px solid #2789EF', icon: EditCalendarOutlinedSvg },
    { key: 'declined', label: 'Declined Requests', border: '1px solid #EF272E', icon: EventBusyOutlinedSvg },
];

// ── Styles ─────────────────────────────────────────────────────────────────
const styles = {
    gridItem: { flexBasis: '20%', maxWidth: '20%' },
    card: {
        borderRadius: '8px',
        padding: '24px 16px',
        bgcolor: '#fff',
        boxShadow: '0 0 4px 0 rgba(0,0,0,0.10)',
        minHeight: 144,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    label: { letterSpacing: '0.15px' },
    count: { letterSpacing: '0.25px' },
};

const AppointmentRequestCards = ({ counts = {} }) => {
    const { isOpenSideBar } = useContext(Context);
    return (
        <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
            {cardConfig.map(({ key, label, icon: Icon, border }) => (
                <Grid item xs={12} sm={isOpenSideBar ? 12 : 6} md={isOpenSideBar ? 6 : 3} lg={3} key={key}>
                    <Box sx={{ ...styles.card, border }}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Icon />
                            <Typography variant="body1" sx={styles.label}>
                                {label}
                            </Typography>
                        </Box>
                        <Typography variant="h4" sx={styles.count}>
                            {counts[key] ?? 0}
                        </Typography>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
};

export default AppointmentRequestCards;
